import { OnInit, Injector, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { TableConfig } from '../entities/table-config';
import { NzModalService, NzMessageService } from 'ng-zorro-antd';
import { STableService } from '../components/s-table/s-table.service';
// import {STableService} from 'sailing-front';
import { HttpService } from '../services/http/http-service.service';
// import {CommonService} from 'sailing-front';
import { CommonService } from '../services/common/common.service';
import { STableComponent } from '../components/s-table/s-table.component';
export class TableBase implements OnInit {
    //    @Output() dialogParams: EventEmitter<any> =  new EventEmitter();
    @Input() dialogParams;

    @ViewChild(STableComponent) table: STableComponent;
    modal: NzModalService;
    message: NzMessageService;
    httpService: HttpService;
    commonService: CommonService;
    tableService: STableService;
    constructor(
        injector: Injector
    ) {
        this.getInjector(injector);
    }
    // 是否弹出删除确认框
    isConfirm = true;
    // 表格对象
    tableObjSync: TableConfig = new TableConfig();
    ngOnInit() {
        const tableConfig = this.getConfig();
        this.tableObjSync = {
            ...this.tableObjSync,
            ...tableConfig,
        };
    }

    getConfig() {
        return {};
    }
    getInjector(injector) {
        this.modal = injector.get(NzModalService);
        this.message = injector.get(NzMessageService);
        this.httpService = injector.get(HttpService);
        this.commonService = injector.get(CommonService);
        this.tableService = injector.get(STableService);
    }
    /**
     * 删除数据
     */
    deleteRowData(id, url, title?, modalContent?, message?) {
        if (!id) {
            this.message.error('请选择要删除的数据');
            return;
        }
        let errMsg = '确定要删除选中数据吗';
        if (message) {
            errMsg = message;
        }
        let errContent = `<b style="color: red;">${errMsg}</b>`;
        if (modalContent) {
            errContent = modalContent;
        }
        if (this.isConfirm) {
            this.modal.confirm({
                nzTitle: title || '提示',
                nzContent: errContent,
                nzOkText: '确定',
                nzOkType: 'danger',
                nzOnOk: () => this.deleteByHttp(id, url),
                nzCancelText: '取消',
                nzOnCancel: () => console.log('Cancel')
            });
        } else {
            this.deleteByHttp(id, url);
        }
    }

    // 删除数据
    deleteByHttp(id, url) {
        const deleteUrl = `${url}/${id}`;
        this.httpService.httpDelete(deleteUrl).subscribe(res => {
            if (res.code === 1) {
                this.message.success('删除成功');
                this.reloadTable();
                this.afterDelete();
            }
        });
    }
    afterDelete() { }

    // 打开对话框(弹框/抽屉)
    openModalDialog(params?) {
        const dialogObj = {
            content: this.getComponent(),
            params,
        };
        this.openModal(dialogObj);
    }

    // 抽屉
    openDrawer(obj) {
        const dialogObj = {
            type: 'drawer',
            title: obj.title || 'DrawerComponent',
            params: obj.params || null,
            content: obj.content,
            style: {
                width: obj.width
            }
        };
        const d = this.commonService.createModal(dialogObj);
        d.afterClose.subscribe(() => {
            this.reloadTable();
            this.afterClose(obj.content);
        });
    }


    // 弹框
    openModal(obj) {
        const dialogObj = {
            type: 'modal',
            title: obj.title || 'ModalComponent',
            params: obj.params || null,
            content: obj.content,
            footer: obj.footer || null,
        };
        const d = this.commonService.createModal(dialogObj);
        d.afterClose.subscribe(() => {
            this.reloadTable();
            this.afterClose();
        });
    }

    // 弹框/抽屉关闭后
    afterClose(component?) {

    }
    // 获取弹框/抽屉组件
    getComponent() {
        return null;
    }
    // 刷新表格
    reloadTable() {
        // this.tableObjSync = this.tableService.refreshTabl(this.tableObjSync);
        // this.table.tableConfig.queryTitle = false;
        this.table.tableConfig.defaultLoad = true;
        this.table.getDynamicTableData();
    }

}
